"use client";

import ProductItem from "./productItem";
import { useEffect, useState } from "react";
import fetchGraphQL from "../helper/fetch";
import FilterMenu from "./filterSection";
import { useSearchParams } from "next/navigation";

async function GetProducts(
  limit: number = 12,
  skip: number = 0,
  searchFilter: any = {
    name: "",
    minPrice: 0,
    maxPrice: 0,
    brand: "",
    type: "",
    isDiscounted: false, // Added isDiscounted filter
  }
) {
  const { name, minPrice, maxPrice, brand, type, isDiscounted, anime } =
    searchFilter;
  const filters = [];
  if (name) filters.push(`name_contains: "${name}" `);
  if (minPrice) filters.push(`price_gte: ${minPrice} `); // Minimum price condition
  if (maxPrice) filters.push(`price_lte: ${maxPrice} `);
  if (brand) filters.push(`brand_contains_some: "${brand}" `); // Minimum price condition
  if (type) filters.push(`type_contains: "${type}" `);
  if (anime) filters.push(`animeName_contains: "${anime}" `);

  if (isDiscounted) filters.push(`discount_gt: 0, discount_not: null`);

  const whereClause = filters.length ? `where: { ${filters.join(", ")} }` : "";

  const QUERY = `query {
        productCollection(limit: ${limit}, skip: ${skip}, ${whereClause}) {            
            total,
            items {
                _id,  
                name,
                price,
                discount,
                image {   
                    url
                }
				brand,
				type,
        animeName
            }
        }
    }`;

  const result = await fetchGraphQL(QUERY);
  console.log(result, "result");
  return {
    total: result.data?.productCollection.total,
    products: result.data?.productCollection.items?.map((item: any) => {
      return {
        key: item._id,
        image: item.image.url,
        discount: item.discount,
        title: item.name,
        price: item.price,
      };
    }),
  };
}

export default function ProductSection({ menu }: { menu: any }) {
  const searchParams = useSearchParams();

  // Get the "next" query parameter
  const isDiscounted = searchParams.get("type") == "discounted";

  const [skip, setSkip] = useState(0);
  const [page, setPage] = useState(1);

  const [total, setTotal] = useState(0);
  const [searchFilter, setSearchFilter] = useState({
    name: "",
    minPrice: 0,
    maxPrice: 1000,
    brand: "Banpresto",
    type: "",
    isDiscounted: false,
    anime: "",
  });

  useEffect(() => {
    setSearchFilter({ ...searchFilter, isDiscounted });
  }, [isDiscounted]);

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [products, setProducts] = useState<any[]>([]);
  // const [formData, setFormData] = useState({
  // 	search: "",
  // 	priceRange: 0,
  // 	brand1: "",
  // 	brand2: "",
  // 	brand3: "",
  // });
  console.log("searchFilter=>", searchFilter, products);

  // useEffect(() => {
  // 	GetProducts().then((data: any) => {
  // 		setTotal(data.total);
  // 		setProducts(data.products);
  // 	});
  // }, []);

  useEffect(() => {
    setIsLoading(true);
    GetProducts(12, skip, searchFilter).then((data: any) => {
      setIsLoading(false);

      setTotal(data?.total);
      setProducts(data?.products);
    });
  }, [searchFilter?.name]);

  const handleClick = () => {
    const newSkip = skip + 12;

    setSkip(newSkip);
    setIsLoading(true);

    GetProducts(12, newSkip, searchFilter).then((data: any) => {
      setIsLoading(false);

      setTotal(data.total);
      setProducts([...products, ...data.products]);
    });
  };

  // console.log()

  const handleChange = (name: string, value: any, defaultValue: any) => {
    setSearchFilter((old: any) => ({
      ...old,
      [name]: old[name] === value ? defaultValue : value, // Reset to default if value is the same
    }));
  };

  const handleFormSubmit = (e: any) => {
    e.preventDefault();
    setIsLoading(true);

    GetProducts(12, 0, searchFilter).then((data: any) => {
      setIsLoading(false);

      setTotal(data?.total);
      setProducts(data?.products);
    });
    // TODO: filter parameters to be added in the URL. When someone refreshes the page, the filters will remain
  };

  const filters = [
    {
      index: "01",
      title: "Фигурки",
      type: "category",
      // subcategories: ["Subcategory 1", "Subcategory 2"],
    },
    {
      index: "02",

      title: "Qposket",
      type: "category",
      // subcategories: ["Subcategory 1", "Subcategory 2"],
    },
    {
      index: "03",
      title: "Qposket-petit",
      type: "category",
      // subcategories: ["Subcategory 1", "Subcategory 2"],
    },
    {
      index: "04",
      title: "Funko POP",
      type: "category",
      // subcategories: ["Subcategory 1", "Subcategory 2"],
    },
    {
      index: "05",
      title: "Плюшки",
      type: "category",
      // subcategories: ["Subcategory 1", "Subcategory 2"],
    },
    {
      index: "06",
      title: "Падове",
      type: "category",
      // subcategories: ["Subcategory 1", "Subcategory 2"],
    },
    {
      index: "07",
      title: "Други",
      type: "category",
      // subcategories: ["Subcategory 1", "Subcategory 2"],
    },
    {
      index: "08",
      title: "gundam",
      type: "category",
      // subcategories: ["Subcategory 1", "Subcategory 2"],
    },
  ];

  const price = [
    {
      index: "09",

      title: "Цена",
      type: "price",
      subcategories: null, // No subcategories for price
    },
  ];

  const brands = [
    {
      title: "Banpresto",
      index: "14",
      // subcategories: [{ title: "one" }, { title: "two" }],
    },
    {
      title: "SEGA",
      index: "15",
      // subcategories: [{ title: "one" }, { title: "two" }],
    },
    {
      title: "Funko POP",
      index: "16",
      // subcategories: [{ title: "one" }, { title: "two" }],
    },
    {
      title: "Furyu",
      index: "17",
      // subcategories: [{ title: "one" }, { title: "two" }],
    },
    {
      title: "Good Smile Company",
      index: "18",
      // subcategories: [{ title: "one" }, { title: "two" }],
    },
    {
      title: "Jaya",
      index: "19",
      // subcategories: [{ title: "one" }, { title: "two" }],
    },
    {
      title: "Taito",
      index: "20",
      // subcategories: [{ title: "one" }, { title: "two" }],
    },
    {
      title: "Coreful",
      index: "21",
      // subcategories: [{ title: "one" }, { title: "two" }],
    },
  ];

  const animes = [
    {
      title: "Demon Slayer",
      index: "21",
      // subcategories: [{ title: "one" }, { title: "two" }],
    },
    {
      title: "Jujutsu Kaisen",
      index: "22",
      // subcategories: [{ title: "one" }, { title: "two" }],
    },
    {
      title: "Naruto",
      index: "23",
      // subcategories: [{ title: "one" }, { title: "two" }],
    },
    {
      title: "One Piece",
      index: "24",
      // subcategories: [{ title: "one" }, { title: "two" }],
    },
    {
      title: "Dragon Ball Z",
      index: "25",
      // subcategories: [{ title: "one" }, { title: "two" }],
    },
    {
      title: "My Hero Academia",
      index: "26",
      // subcategories: [{ title: "one" }, { title: "two" }],
    },
    {
      title: "That Time Got Reincarnated As A Slime",
      index: "27",
      // subcategories: [{ title: "one" }, { title: "two" }],
    },
    {
      title: "Chainsaw Man",
      index: "21",
      // subcategories: [{ title: "one" }, { title: "two" }],
    },
  ];

  return (
    <div id="products" className="products">
      <div className="shell md:px-[40px]">
        <div className="products__inner">
          <header className="products__head">
            <h2>Нашите продукти</h2>
          </header>

          <div className="grid lg:grid-cols-4 grid-cols-1 gap-y-5 md:gap-3">
            {menu && (
              <form className="col-span-1">
                <FilterMenu
                  // colors={colors}
                  // sizes={sizes}
                  // buns={buns}
                  price={price}
                  filters={filters}
                  brands={brands}
                  animes={animes}
                  {...{ searchFilter, setSearchFilter, handleChange }}
                />
                <button className="btn w-full mt-4" onClick={handleFormSubmit}>
                  Приложи
                </button>
              </form>
            )}
            <div
              className={` flex mb-8 justify-center ${
                menu ? "col-span-3" : "col-span-4 "
              }`}
            >
              <div
                className={`h-fit grid gap-6 ${
                  menu
                    ? " grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
                    : "  grid-cols-1 md:grid-cols-2 lg:grid-cols-4"
                }`}
              >
                {menu ? (
                  <>
                    {products.length > 0 ? (
                      <>
                        {products?.map((item) => (
                          <ProductItem key={item.key} item={item} />
                        ))}
                      </>
                    ) : isLoading ? (
                      <div>Loading data...</div>
                    ) : (
                      <div>Matching products not found!</div>
                    )}
                  </>
                ) : (
                  <>
                    {products.length > 0 ? (
                      <>
                        {products?.map((item) => {
                          if (item.discount > 0)
                            return <ProductItem key={item.key} item={item} />;
                        })}{" "}
                      </>
                    ) : isLoading ? (
                      <div>Loading data...</div>
                    ) : (
                      <div>Matching products not found!</div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="flex w-full justify-center items-center">
          {total > products?.length && (
            <div className="">
              <a onClick={handleClick} className="btn btn--outlined">
                Виж още
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
